'use strict';
const createSVGDOM = require('./create-svg-dom'),
	createSVGContainer = () => {
		const result = createSVGDOM();
		result.style.position = 'absolute';
		result.style.top = '0px';
		result.style.left = '0px';
		result.setAttribute('data-mapjs-role', 'svg-container');
		result.setAttribute('class', 'mapjs-draw-container');
		return result;
	},
	css = require('../dom/css');

module.exports = function buildStageDOM(viewportDOM) {

	const stageDOM = viewportDOM.ownerDocument.createElement('div'),
		svgContainerDOM = createSVGContainer();
	css(stageDOM, {position: 'relative'});
	stageDOM.setAttribute('data-mapjs-role', 'stage');
	stageDOM.appendChild(svgContainerDOM);
	viewportDOM.appendChild(stageDOM);
	return stageDOM;
};
